import React, {Fragment} from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import Select from "../../form/Select";
import AddressControl from "../../form/AddressControl";
import {CurrencyFormatter, UnitFormatter} from "../../../utils/formatters";
import classNames from 'classnames';
import Button from "../../form/Button";
import connect from "react-redux/es/connect/connect";
import {isEmpty} from "../../../utils/other";
import DateTimeInput from "../../form/DateTimeInput";
import TextArea from "../../form/TextArea";

class EventReservationForm extends React.Component {

    render() {
        const disabled = this.props.values[this.props.componentConfig.idfield];
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-md-2">
                        <TextInput
                            name={this.props.componentConfig.idfield}
                            value={this.props.values[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield"
                            {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                        />
                    </div>
                    <div className="col-md-2">
                        <DateTimeInput
                            name="created_at"
                            value={this.props.values.created_at}
                            label="Foglalás dátuma"
                            {...this.props.getFieldProps("created_at")}
                            disabled="disabled"
                        />
                    </div>
                    {!(this.props.presets || {}).event && <div className="col-md-4">
                        <Select
                            component="Event"
                            name="event"
                            value={this.props.values.event}
                            label="Esemény"
                            view={["program.name", "program.id"]}
                            selectedOptionTemplate={(props) => {
                                return props.id + " - " + ((props.program || {}).name || "") + " (#" + (props.program || {}).id + ")";
                            }}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("event")}
                            disabled={disabled}
                        />
                    </div>}
                    <div className={classNames("currency", {"col-md-4": (this.props.presets || {}).event, "col-md-2": !(this.props.presets || {}).event})}>
                        <TextInput
                            name="saleprice"
                            type="number"
                            value={this.props.values.saleprice}
                            formatter={CurrencyFormatter}
                            label="Ár"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("saleprice")}
                            disabled={disabled}
                        />
                    </div>
                    <div className={classNames("", {"col-md-4": (this.props.presets || {}).event, "col-md-2": !(this.props.presets || {}).event})}>
                        <TextInput
                            name="participant_qty"
                            type="number"
                            value={this.props.values.participant_qty || 0}
                            formatter={(value) => UnitFormatter(value, "Fő")}
                            label="Résztvevők/Létszám"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("participant_qty")}
                            disabled={disabled}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-3">
                        <Select
                            objectValue={true}
                            name="customer"
                            component="partner"
                            labelKey="name"
                            valueKey="partner_id"
                            storeType="remote"
                            value={this.props.values.customer}
                            saveChanges={this.props.setFieldValue}
                            label="Számlázási adatok"
                            {...this.props.getFieldProps("customer")}
                        />
                    </div>
                    <div className="col-md-9">
                        <div className="row">
                            <AddressControl
                                disabled={"disabled"}
                                name="customer.address"
                                value={(this.props.values.customer || {}).address}
                                label="Cím"
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-4">
                        <Select
                            objectValue={true}
                            name="agent"
                            component="partner"
                            labelKey="name"
                            valueKey="partner_id"
                            storeType="remote"
                            value={this.props.values.agent}
                            saveChanges={this.props.setFieldValue}
                            label="Foglaló"
                            {...this.props.getFieldProps("agent")}
                        />
                    </div>
                    <div className="col-md-4">
                        <TextInput
                            {...this.props.getFieldProps("agent")}
                            disabled="disabled"
                            name="agent.email"
                            value={(this.props.values.agent || {}).email}
                            label="Email"
                        />
                    </div>
                    <div className="col-md-4">
                        <TextInput
                            {...this.props.getFieldProps("agent")}
                            disabled="disabled"
                            name="agent.telnum"
                            value={(this.props.values.agent || {}).telnum}
                            label="Telefon"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <div className="row">
                            <AddressControl
                                disabled={"disabled"}
                                name="agent.address"
                                value={(this.props.values.agent || {}).address}
                                label="Cím"
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <TextArea
                            name="comment.text"
                            value={(this.props.values.comment || {}).text}
                            label="Megjegyzés"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("comment.text")}
                        />
                    </div>
                </div>
                {this.props.values[this.props.componentConfig.idfield] && <div className="row form-row">
                    <div className="col-md-3">
                        <TextInput
                            name="participant_qty"
                            value={parseInt(this.props.participant_qty)}
                            formatter={(value) => UnitFormatter(value, "+ Fő")}
                            label={parseInt(this.props.participant_qty) + " + Fő"}
                            {...this.props.getFieldProps("participant_qty")}
                            saveChanges={(field, participant_qty) => this.props.setParticipantQty(participant_qty)}
                        />
                    </div>
                    <div className="col-md-4">
                        <TextInput
                            name="price"
                            value={this.props.price}
                            formatter={CurrencyFormatter}
                            label="Felár"
                            {...this.props.getFieldProps("price")}
                            disabled={true}
                        />
                    </div>
                    <div className="col-md-3">
                        <Select
                            label="Pénztár"
                            name="moneyrepository"
                            component="MoneyRepository"
                            options={this.props.till.moneyrepositories}
                            objectValue={false}
                            labelKey="paymentlabel"
                            valueKey="repository_id"
                            storeType="local"
                            {...this.props.getFieldProps("moneyrepository")}
                            value={this.props.moneyrepository}
                            disabled={this.props.isLoading}
                            saveChanges={(field, moneyrepository) => this.props.setMoneyRepository(moneyrepository)}
                        />
                    </div>
                    <div className="col-md-2">
                        <label className="control-label">&nbsp;</label>
                        <Button
                            disabled={this.props.isLoading || this.props.priceLoading === true || !this.props.moneyrepository || isEmpty(this.props.participant_qty) || isEmpty(this.props.price)}
                            color="default"
                            block={true}
                            onClick={this.props.updateParticipants}
                        >
                            Módosítás
                        </Button>
                    </div>
                </div>}
            </form>
        );
    }
}

export default connect((state) => {
    return {
        till: state.app.till
    };
}, {})(createForm(EventReservationForm));
